<template>
  <div class="lang-select">
    <p class="text-xs my-24">{{ $t('langSelectInfo') }}</p>
    <div class="flex flex-wrap w-full text-sm font-medium">
      <li v-for="lang in this['user/langsList']" :key="lang.code"
        class="list-reset flex items-center justify-between mr-16 mb-8 p-8 py-16 cursor-pointer rounded-sm hover:bg-blue-lightest" style="width: calc((100% - 3rem)/3)"
        :class="lang.code === selectedLang && 'bg-blue-lightest'"
        @click="switchLang(lang.code)"
      >
        <div class="flex items-center">
          <!-- <CountryFlag :country="lang.flag" size='normal' class="rounded-sm" style="margin: 0 -0.7em; border: 1px solid #dddfe2;"/> -->
          <div class="ml-8">
            {{ lang.name }}
          </div>
        </div>
        <div v-if="lang.code === selectedLang">
          <i class="owl owl-status-check text-blue"></i>
        </div>
      </li>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CountryFlag from 'vue-country-flag'

export default {
  name: 'langSelect',
  components: {
    CountryFlag
  },
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      'user/langsList': 'user/langsList',
      selectedLang: 'user/selectedLang',
      'user/selectedLangName': 'user/selectedLangName'
    })
  },
  methods: {
    ...mapActions([
      'user/switchLang'
    ]),
    switchLang (lang) {
      this['user/switchLang'](lang)
      this.$modal.hide('langSelect')
    }
  },
  watch: {
    isDesktop: {
      handler: function (newVal, oldVal) {
        if (!newVal) {
          this.$modal.hide('langSelect')
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.lang-select
  @apply mx-24
  min-width: 350px
  .warning
</style>
